import { render, staticRenderFns } from "./QualityAssuranceLabelPreview.vue?vue&type=template&id=308dc1c4"
import script from "./QualityAssuranceLabelPreview.vue?vue&type=script&lang=js"
export * from "./QualityAssuranceLabelPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports